export default interface Link {
  id?: number;
  url: string;
  'created_at': string;
  'updated_at': string;
}

export const emptyLink = (): Link => ({
  url: '',
  created_at: '',
  updated_at: ''
})
